import React from 'react';

interface Context {
  fetchUserPreviewData: () => Promise<void>;
}

export const UserPreviewContext = React.createContext({} as Context);

export const UserPreviewProvider = UserPreviewContext.Provider;
